var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useField, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import FormikAutocomplete from '../formik/FormikAutocomplete';
export const InlineAutocomplete = (_a) => {
    var { name } = _a, props = __rest(_a, ["name"]);
    const formik = useFormikContext();
    const [field, meta, { setValue, setTouched, setError }] = useField(name);
    const [previousValue, setPreviousValue] = useState(meta.initialValue);
    const [lastSubmitCount, setLastSubmitCount] = useState(formik.submitCount);
    useEffect(() => {
        // update previous value if initial value changes
        setPreviousValue(meta.initialValue);
    }, [meta.initialValue]);
    useEffect(() => {
        if (!formik.isSubmitting && lastSubmitCount !== formik.submitCount) {
            // form finished submitting so set current value to previous value
            setPreviousValue(meta.value);
            setLastSubmitCount(formik.submitCount);
        }
    }, [formik.isSubmitting, formik.submitCount, lastSubmitCount, meta.value]);
    return (React.createElement(FormikAutocomplete, Object.assign({ name: name }, props, { onKeyDown: event => {
            // console.log('event.key', event.key);
            switch (event.key) {
                case 'Escape':
                    setTouched(false);
                    setValue(previousValue);
                    break;
                // case 'Tab':
                // case 'Enter':
                //   return handleSubmit();
            }
        }, onBlur: event => {
            setTouched(true);
            formik.submitForm();
        } })));
};
export default InlineAutocomplete;
//# sourceMappingURL=InlineAutocomplete.js.map